import React from 'react';

function MachineInfo(props){
    return (
        <div className={"machine-info trouble-border"}>
            <span className="title">Makina</span>
            <span className="name">{props.name}</span>
            <span className="code" style={{display:"none"}}>({props.code})</span>
        </div>
    )
}


export default MachineInfo;